/* eslint-disable */
import request from './helpers'

export function listService (size, page) {
    return request({
        url: '/api/v1/handler',
        method: 'get',
        params: {
          size,
          page
        }
    })
}

export function createService (data) {
    return request({
        url: '/api/v1/handler',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function listServiceById (id) {
    return request({
        url: '/api/v1/handler/' + id,
        method: 'get'
    })
}

export function updateService (id, data) {
    return request({
        url: '/api/v1/handler/' + id,
        method: 'put',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function deleteService (id) {
    return request({
        url: '/api/v1/handler/' + id,
        method: 'delete'
    })
}

export function listPool (id) {
    return request({
        url: '/api/v1/handler/' + id + '/pool',
        method: 'get'
    })
}

export function createPool (data) {
    return request({
        url: '/api/v1/handler/pool',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function duplicatePool (id, data) {
    return request({
        url: '/api/v1/handler/pool/duplicate/' + id,
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function updatePool (id, data) {
    return request({
        url: '/api/v1/handler/pool/' + id,
        method: 'put',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function deletePool (id) {
    return request({
        url: '/api/v1/handler/pool/' + id,
        method: 'delete'
    })
}

export function listApplication (serviceId, poolId, size, page) {
    return request({
        url: '/api/v1/handler/' + serviceId + '/pool/' + poolId,
        method: 'get',
        params: {
          size,
          page
        }
    })
}

export function searchServicePoolApplication (data, serviceId, poolId, size, page) {
    return request({
        url: '/api/v1/handler/' + serviceId + '/pool/' + poolId + '/search',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data,
        params: {
          size,
          page
        }
    })
}

export function createApplication (data) {
    return request({
        url: '/api/v1/handler/pool/application',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function editApplication (data) {
    return request({
        url: '/api/v1/handler/pool/application/edit',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function deleteApplication (id) {
    return request({
        url: '/api/v1/handler/pool/application/' + id,
        method: 'delete'
    })
}

export function listStrategy () {
    return request({
        url: '/api/v1/handler/config/strategy',
        method: 'get'
    })
}

export function searchServiceClients (id, data, params) {
    return request({
        url: '/api/v1/handler/tag/' + id + '/search',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data,
        params
    })
}

export function listClient (id, params) {
    return request({
        url: '/api/v1/handler/tag/' + id,
        method: 'get',
        params
    })
}

export function setTags (data) {
    return request({
        url: '/api/v1/handler/tag',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}
export function deleteTags (data) {
    return request({
        url: '/api/v1/handler/tag',
        method: 'delete',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function listPoolClient (id, params) {
    return request({
        url: '/api/v1/handler/tag/pool/' + id,
        method: 'get',
        params
    })
}

export function searchSchedulingResult (data, params) {
    return request({
        url: '/api/v1/handler/scheduling/result',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data,
        params
    })
}
